// 邀请好友
import {http} from '@/utils/http'

export const getInvite = data => http('/Account/get_invite_record',data,'post')